import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { ArrowIcon } from '../Icons';

interface BackButtonProps {
    onClick: () => void;
}

const useStyles = createUseStyles({
    backButton: {
        border: 'none',
        color: 'var(--primary-color)',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        paddingRight: '2rem',
        '& > *': {
            transition: 'transform .1s',
        },
        '&:hover > *': {
            transform: 'translateX(-.5rem)',
        },
    },
});

const BackButton: React.FC<BackButtonProps> = ({ onClick }: BackButtonProps) => {
    const classes = useStyles();

    return (
        <button className={classes.backButton} onClick={onClick}>
            <ArrowIcon rotation={180} />
        </button>
    );
};

export default React.memo(BackButton);
